import { FC } from 'react';

import Background from './components/Background/Background';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import './styles/main.css';

const App: FC = () => {
  return (
    <>
      <Background />
      <div className="app-container">
        <Header />
        <main id="main-content" role="main"></main>
        <Footer />
      </div>
    </>
  );
};

export default App;
